import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
    Container, Typography, Paper, Box, Button, List, ListItem, ListItemText, ListItemIcon,
    Dialog, DialogTitle, DialogContent, TextField, DialogActions, Table,
    TableBody, TableCell, TableHead, TableRow, Tabs, Tab, Grid, Card, CardContent, CardActions,
    Select, MenuItem, FormControl, InputLabel, IconButton, LinearProgress, Checkbox,
    Accordion, AccordionSummary, AccordionDetails, Chip, Avatar, Divider, Tooltip, CircularProgress,
    ListItemSecondaryAction, Stepper, Step, StepLabel, StepButton, Autocomplete, ListItemAvatar, Grow, OutlinedInput
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import CloseIcon from '@mui/icons-material/Close';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AddIcon from '@mui/icons-material/Add';
import DownloadIcon from '@mui/icons-material/Download';
import QrCodeIcon from '@mui/icons-material/QrCode';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AssignmentIcon from '@mui/icons-material/Assignment';
import EventIcon from '@mui/icons-material/Event';
import PublicIcon from '@mui/icons-material/Public';
import BusinessIcon from '@mui/icons-material/Business';
import FlagIcon from '@mui/icons-material/Flag';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import DescriptionIcon from '@mui/icons-material/Description';
import PersonIcon from '@mui/icons-material/Person';
import SendIcon from '@mui/icons-material/Send';
import CommentIcon from '@mui/icons-material/Comment';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import WarningIcon from '@mui/icons-material/Warning';
import ForumIcon from '@mui/icons-material/Forum';
import FolderIcon from '@mui/icons-material/Folder';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import InfoIcon from '@mui/icons-material/Info';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

import axios from 'axios';
import API_URL from '../config';
import Loading from '../components/Loading';

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    {children}
                </Box>
            )}
        </div>
    );
}

function ITProjectDetails() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [project, setProject] = useState(null);
    const [countries, setCountries] = useState([]);
    const [clients, setClients] = useState([]);
    const [loading, setLoading] = useState(true);
    const [tab, setTab] = useState(0);
    const [chatMessage, setChatMessage] = useState('');
    const [newTask, setNewTask] = useState('');
    const [newTaskDate, setNewTaskDate] = useState('');
    const [newTaskAssignee, setNewTaskAssignee] = useState(''); // ID of assigned user
    const [addingTask, setAddingTask] = useState(false);

    // Task Comment State
    const [openCommentDialog, setOpenCommentDialog] = useState(false);
    const [currentTask, setCurrentTask] = useState(null);
    const [taskComment, setTaskComment] = useState('');

    // Edit Mode State
    const [editOpen, setEditOpen] = useState(false);
    const [editData, setEditData] = useState({});
    const [openTaskDialog, setOpenTaskDialog] = useState(false);

    // Needs/Requirements State
    const [needOpen, setNeedOpen] = useState(false);
    const [newNeed, setNewNeed] = useState({ description: '', priority: 'Medium', due_date: '' });
    const [openNeedCommentDialog, setOpenNeedCommentDialog] = useState(false);
    const [currentNeed, setCurrentNeed] = useState(null);
    const [needComment, setNeedComment] = useState('');

    // Assign Member State
    const [assignOpen, setAssignOpen] = useState(false);
    const [users, setUsers] = useState([]);
    const [selectedUser, setSelectedUser] = useState(null);
    const [assignRole, setAssignRole] = useState('Member'); // Role for new member
    const [assigningMember, setAssigningMember] = useState(false);

    // Link Ticket State
    const [ticketOpen, setTicketOpen] = useState(false);
    const [allTickets, setAllTickets] = useState([]);
    const [selectedTicket, setSelectedTicket] = useState(null);
    const [linkingTicket, setLinkingTicket] = useState(false);

    // Add Ticket State
    const [addTicketOpen, setAddTicketOpen] = useState(false);
    const [ticketTypes, setTicketTypes] = useState([]);
    const [adUsers, setAdUsers] = useState([]);
    const [adLoading, setAdLoading] = useState(false);
    const [newTicket, setNewTicket] = useState({
        title: '', description: '', status: 'Open', priority: 'Medium',
        requested_by: '', sender_email: '', country_id: '',
        ticket_type_id: '',
        assigned_to_ids: [],
        due_date: ''
    });
    const [addingTicket, setAddingTicket] = useState(false);

    // File Upload State
    const fileInputRef = useRef(null);
    const [uploading, setUploading] = useState(false);

    const token = localStorage.getItem('token');
    const headers = { Authorization: `Bearer ${token}` };

    useEffect(() => {
        fetchProject();
        fetchCountries();
        fetchClients();
        fetchUsers();
        fetchTickets();
        fetchTicketTypes();
    }, [id]);

    const fetchTicketTypes = async () => {
        try {
            const res = await axios.get(`${API_URL}/ticket-types`, { headers });
            setTicketTypes(res.data);
        } catch (e) { console.error(e); }
    };

    const handleADSearch = async (query) => {
        if (!query || query.length < 3) {
            setAdUsers([]); return;
        }
        setAdLoading(true);
        try {
            const res = await axios.get(`${API_URL}/tickets/search-ad-users?q=${query}`, { headers });
            setAdUsers(res.data);
        } catch (e) {
            console.error(e);
        } finally {
            setAdLoading(false);
        }
    };

    const fetchTickets = async () => {
        try {
            const res = await axios.get(`${API_URL}/tickets`, { headers });
            setAllTickets(res.data);
        } catch (e) { console.error(e); }
    };

    const fetchUsers = async () => {
        try {
            const res = await axios.get(`${API_URL}/setup/users`, { headers });
            setUsers(res.data);
        } catch (e) { console.error(e); }
    };

    const fetchCountries = async () => {
        try {
            const res = await axios.get(`${API_URL}/setup/countries`, { headers });
            setCountries(res.data);
        } catch (e) {
            console.error(e);
        }
    };

    const fetchClients = async () => {
        try {
            const res = await axios.get(`${API_URL}/clients`, { headers });
            setClients(res.data);
        } catch (e) {
            console.error(e);
        }
    };

    const fetchProject = async () => {
        try {
            const res = await axios.get(`${API_URL}/it-projects/${id}?t=${new Date().getTime()}`, { headers });
            setProject(res.data);
        } catch (e) { console.error(e); }
        finally { setLoading(false); }
    };

    const handleSendMessage = async () => {
        if (!chatMessage.trim()) return;
        try {
            await axios.post(`${API_URL}/it-projects/${id}/chat`, { message: chatMessage }, { headers });
            setChatMessage('');
            fetchProject();
        } catch (e) {
            console.error(e);
        }
    };

    const handleAddTask = async () => {
        if (!newTask.trim()) return;
        setAddingTask(true);
        try {
            await axios.post(`${API_URL}/it-projects/${id}/tasks`, {
                title: newTask,
                assigned_to: newTaskAssignee || null,
                due_date: newTaskDate || null
            }, { headers });
            setNewTask('');
            setNewTaskDate('');
            setNewTaskAssignee('');
            setOpenTaskDialog(false);
            fetchProject();
        } catch (e) {
            console.error(e);
        } finally {
            setAddingTask(false);
        }
    }

    const handleToggleTask = async (taskId, currentInfo) => {
        await axios.put(`${API_URL}/it-projects/tasks/${taskId}`, { completed: !currentInfo }, { headers });
        fetchProject();
    }

    const handleUpdateTaskDate = async (taskId, newDate) => {
        try {
            await axios.put(`${API_URL}/it-projects/tasks/${taskId}`, { due_date: newDate }, { headers });
            fetchProject();
        } catch (e) { console.error(e); }
    }

    const handleDeleteTask = async (taskId) => {
        if (!window.confirm('Are you sure you want to delete this task?')) return;
        try {
            await axios.delete(`${API_URL}/it-projects/tasks/${taskId}`, { headers });
            fetchProject();
        } catch (e) { console.error(e); }
    };

    const handleOpenCommentDialog = (task) => {
        setCurrentTask(task);
        setOpenCommentDialog(true);
    };

    const handleSendTaskComment = async () => {
        if (!taskComment.trim()) return;
        try {
            await axios.post(`${API_URL}/it-projects/tasks/${currentTask.id}/comments`, { comment: taskComment }, { headers });
            setTaskComment('');
            fetchProject();
            // Ideally update local state to show new comment immediately or re-fetch just the task?
            // For now, re-fetching project is fine but might close the dialog if we depend on project state? 
            // Actually we are using `currentTask` which is a snapshot. We should update currentTask with new comment if we want to show it?
            // But our dialog will use `project.tasks.find(...)` to be reactive.
        } catch (e) { console.error(e); }
    };

    const getStatusColor = (status) => {
        switch (status) {
            case 'Active': return 'primary';
            case 'In Progress': return 'primary';
            case 'Completed': return 'success';
            case 'On Hold': return 'warning';
            default: return 'default';
        }
    };

    const calculateProgress = (tasks) => {
        if (!tasks || tasks.length === 0) return 0;
        const completed = tasks.filter(t => t.completed).length;
        return Math.round((completed / tasks.length) * 100);
    };

    const handleEditClick = () => {
        if (editOpen) {
            handleEditSave();
        } else {
            setEditData({
                name: project.name,
                description: project.description,
                status: project.status,
                priority: project.priority,
                country_id: project.country_id || '',
                client_id: project.client_id || '',
                client_id: project.client_id || '',
                time_limit: project.time_limit ? project.time_limit.split('T')[0] : '',
                start_date: project.start_date ? project.start_date.split('T')[0] : ''
            });
            setEditOpen(true);
        }
    };

    const handleEditClose = () => {
        setEditOpen(false);
    };

    const handleEditSave = async () => {
        try {
            await axios.put(`${API_URL}/it-projects/${id}`, editData, { headers });
            setEditOpen(false);
            fetchProject();
        } catch (e) {
            console.error(e);
        }
    };

    const handleEditChange = (field, value) => {
        setEditData(prev => ({ ...prev, [field]: value }));
    };

    const handleAssignMember = async () => {
        if (!selectedUser) return;
        setAssigningMember(true);
        try {
            await axios.post(`${API_URL}/it-projects/${id}/team`, {
                action: 'add',
                user_id: selectedUser.id,
                role: assignRole
            }, { headers });
            setAssignOpen(false);
            setSelectedUser(null);
            setAssignRole('Member');
            fetchProject();
        } catch (e) {
            console.error(e);
            alert('Error assigning member');
        } finally {
            setAssigningMember(false);
        }
    };

    const handleRemoveMember = async (userId) => {
        if (!window.confirm('Remove this member?')) return;
        try {
            await axios.post(`${API_URL}/it-projects/${id}/team`, {
                action: 'remove',
                user_id: userId
            }, { headers });
            fetchProject();
        } catch (e) {
            console.error(e);
        }
    };

    const handleLinkTicket = async () => {
        if (!selectedTicket) return;
        setLinkingTicket(true);
        try {
            await axios.post(`${API_URL}/it-projects/${id}/tickets`, {
                action: 'add',
                ticket_id: selectedTicket.id
            }, { headers });
            setTicketOpen(false);
            setSelectedTicket(null);
            fetchProject();
        } catch (e) {
            console.error(e);
            alert('Error linking ticket');
        } finally {
            setLinkingTicket(false);
        }
    };

    const handleRemoveTicket = async (ticketId) => {
        if (!window.confirm('Remove this ticket from project?')) return;
        try {
            await axios.post(`${API_URL}/it-projects/${id}/tickets`, {
                action: 'remove',
                ticket_id: ticketId
            }, { headers });
            fetchProject();
        } catch (e) {
            console.error(e);
        }
    };

    const handleCreateTicket = async () => {
        if (!newTicket.title.trim()) return;
        setAddingTicket(true);
        try {
            await axios.post(`${API_URL}/tickets`, {
                ...newTicket,
                created_by_id: localStorage.getItem('user_id'),
                it_project_id: id
            }, { headers });
            
            setAddTicketOpen(false);
            setNewTicket({
                title: '', description: '', status: 'Open', priority: 'Medium',
                requested_by: '', sender_email: '', country_id: '',
                ticket_type_id: '', assigned_to_ids: [], due_date: ''
            });
            fetchProject();
            fetchTickets();
        } catch (e) {
            console.error(e);
            alert('Error creating ticket');
        } finally {
            setAddingTicket(false);
        }
    };

    const handleFileUpload = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const formData = new FormData();
        formData.append('file', file);

        setUploading(true);
        try {
            await axios.post(`${API_URL}/it-projects/${id}/documents`, formData, { headers });
            fetchProject();
        } catch (error) {
            console.error(error);
            alert('Failed to upload file');
        } finally {
            setUploading(false);
            if(fileInputRef.current) fileInputRef.current.value = '';
        }
    };
    
    // Download/Delete Helper functions
    const handleDownloadDocument = async (doc) => {
        try {
            const response = await axios.get(`${API_URL}/it-projects/documents/${doc.id}`, {
                headers,
                responseType: 'blob'
            });
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', doc.filename);
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (e) {
            console.error("Download failed", e);
            alert('Failed to download document');
        }
    };

    const handleDeleteDocument = async (docId) => {
        if(!window.confirm("Are you sure you want to delete this document?")) return;
        try {
            await axios.delete(`${API_URL}/it-projects/documents/${docId}`, { headers });
            fetchProject();
        } catch (e) {
            console.error(e);
            alert('Failed to delete document');
        }
    };

    const handleAddNeed = async () => {
        try {
            await axios.post(`${API_URL}/it-projects/${id}/needs`, newNeed, { headers });
            setNeedOpen(false);
            setNewNeed({ description: '', priority: 'Medium', due_date: '' });
            fetchProject();
        } catch (e) {
            console.error(e);
            alert('Error adding requirement');
        }
    };

    const handleDeleteNeed = async (needId) => {
        if (!window.confirm('Delete this requirement?')) return;
        try {
            await axios.delete(`${API_URL}/it-projects/needs/${needId}`, { headers });
            fetchProject();
        } catch (e) {
            console.error(e);
        }
    };

    const handleToggleNeedStatus = async (need) => {
        const newStatus = need.status === 'Met' ? 'Pending' : 'Met';
        try {
            await axios.put(`${API_URL}/it-projects/needs/${need.id}`, { status: newStatus }, { headers });
            fetchProject();
        } catch (e) {
            console.error(e);
        }
    };

    const handleOpenNeedComments = (need) => {
        setCurrentNeed(need);
        setOpenNeedCommentDialog(true);
        setNeedComment('');
    };

    const handleSendNeedComment = async () => {
        if (!currentNeed || !needComment.trim()) return;
        try {
            await axios.post(`${API_URL}/it-projects/needs/${currentNeed.id}/comments`, { comment: needComment }, { headers });
            setNeedComment('');
            fetchProject();
            // Update local currentNeed comments? fetchProject updates project state, but currentNeed is separate state.
            // Better to refind need from project state or just let next render update it if we used ID.
            // But currentNeed is an object. We should rely on project state for rendering dialog list if possible, or update currentNeed.
            // Let's just update currentNeed manually for now to see immediate result if we don't refetch or if refetch is slow.
            // Actually, since we fetchProject(), the project state updates. If we use project.needs.find... in the dialog, it will auto update.
        } catch (e) {
            console.error(e);
        }
    };

    const handleUpdateNeedComment = async (needId, comment) => {
        try {
            await axios.put(`${API_URL}/it-projects/needs/${needId}`, { comment }, { headers });
            fetchProject();
        } catch (e) {
            console.error(e);
        }
    };

    const steps = ['Open', 'In Progress', 'Completed'];
    const activeStep = steps.indexOf(project?.status) !== -1 ? steps.indexOf(project?.status) : 0;

    const handleStepClick = async (stepLabel) => {
        // Allow updating status by clicking steps? Or just visuals?
        // Let's allow update if desired, or at least show it.
        // For now, let's just use it as visual aid in overview, maybe interactively.
        if (!window.confirm(`Change status to ${stepLabel}?`)) return;
        try {
            await axios.put(`${API_URL}/it-projects/${id}`, { status: stepLabel }, { headers });
            fetchProject();
        } catch (e) { console.error(e); }
    };

    const handleExportPDF = async () => {
        try {
            const response = await axios.get(`${API_URL}/it-projects/${id}/export-pdf`, {
                headers,
                responseType: 'blob'
            });
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `Project_Report_${project.ref_number || id}.pdf`);
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (e) {
            console.error("Export failed", e);
            const msg = e.response?.data?.error || 'Failed to export PDF';
            try {
                // If blob response is JSON error
                if (e.response?.data instanceof Blob) {
                    const text = await e.response.data.text();
                    const json = JSON.parse(text);
                    if (json.error) alert(json.error);
                    else alert(msg);
                } else {
                    alert(msg);
                }
            } catch {
                alert(msg);
            }
        }
    };

    if (loading) return <Loading />;
    if (!project) return <Typography>Project not found</Typography>;

    return (
        <Box sx={{ width: '100%', overflowX: 'hidden', boxSizing: 'border-box', pb: 6, px: { xs: 1, md: 3 }, bgcolor: '#f4f6f8', minHeight: '100vh' }}>
            
            {/* Modern Gradient Header */}
            <Grow in={true} timeout={500}>
            <Paper elevation={0} sx={{ 
                mb: 4, 
                mt: 2, 
                p: 4, 
                borderRadius: 4, 
                background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)', 
                color: 'white',
                boxShadow: '0 10px 30px rgba(30, 60, 114, 0.2)',
                position: 'relative',
                overflow: 'hidden'
            }}>
                <Box sx={{ position: 'absolute', top: -50, right: -50, width: 200, height: 200, borderRadius: '50%', background: 'rgba(255,255,255,0.05)' }} />
                <Box sx={{ position: 'absolute', bottom: -100, right: 100, width: 250, height: 250, borderRadius: '50%', background: 'rgba(255,255,255,0.05)' }} />

                <Box sx={{ position: 'relative', zIndex: 2 }}>
                    <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, alignItems: { xs: 'flex-start', md: 'flex-start' }, justifyContent: 'space-between', gap: 3 }}> 
                        <Box sx={{ flex: 1 }}>
                            <Button
                                startIcon={<ArrowBackIcon />}
                                onClick={() => navigate('/it-projects')}
                                sx={{ color: '#90caf9', mb: 2, pl: 0, fontWeight: 'bold', '&:hover': { color: 'white', bgcolor: 'transparent', transform: 'translateX(-4px)' }, transition: 'all 0.2s' }}
                            >
                                Back to IT Projects
                            </Button>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 1.5 }}>
                                <Avatar sx={{ 
                                    width: 52, height: 52, flexShrink: 0,
                                    bgcolor: 'rgba(255,255,255,0.15)', 
                                    color: '#e3f2fd', 
                                    boxShadow: '0 6px 18px rgba(0,0,0,0.2)',
                                    border: '2px solid rgba(255,255,255,0.2)',
                                }}>
                                    <AssignmentIcon sx={{ color: 'white', fontSize: 26 }} />
                                </Avatar>
                                <Typography variant="h5" fontWeight="900" sx={{ letterSpacing: 0.3, wordBreak: 'break-word', color: 'white', lineHeight: 1.3 }}>
                                    {project.name}
                                </Typography>
                            </Box>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap', ml: 0.5, mt: 1.5 }}>
                                <Box sx={{ 
                                  display: 'flex', alignItems: 'center', gap: 0.8, 
                                  bgcolor: 'rgba(255,255,255,0.18)', backdropFilter: 'blur(8px)',
                                  px: 1.8, py: 0.7, borderRadius: 3,
                                  border: '1px solid rgba(255,255,255,0.2)',
                                }}>
                                  <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: (project.status || '').toLowerCase() === 'completed' ? '#4ade80' : (project.status || '').toLowerCase() === 'in progress' ? '#facc15' : '#60a5fa', boxShadow: `0 0 6px ${(project.status || '').toLowerCase() === 'completed' ? '#4ade80' : (project.status || '').toLowerCase() === 'in progress' ? '#facc15' : '#60a5fa'}` }} />
                                  <Typography variant="caption" sx={{ color: 'white', fontWeight: 700, letterSpacing: 0.3, fontSize: '0.75rem' }}>
                                    {project.status}
                                  </Typography>
                                </Box>
                                {project.ref_number && (
                                    <Box sx={{ 
                                      display: 'flex', alignItems: 'center', gap: 0.8, 
                                      bgcolor: 'rgba(255,255,255,0.1)', backdropFilter: 'blur(8px)',
                                      px: 1.8, py: 0.7, borderRadius: 3,
                                      border: '1px solid rgba(255,255,255,0.12)',
                                    }}>
                                      <QrCodeIcon sx={{ color: '#c4b5fd', fontSize: 14 }} />
                                      <Typography variant="caption" sx={{ color: '#e2e8f0', fontWeight: 600, fontSize: '0.75rem' }}>
                                        {project.ref_number}
                                      </Typography>
                                    </Box>
                                )}
                                {project.country_name && (
                                    <Box sx={{ 
                                      display: 'flex', alignItems: 'center', gap: 0.8, 
                                      bgcolor: 'rgba(255,255,255,0.1)', backdropFilter: 'blur(8px)',
                                      px: 1.8, py: 0.7, borderRadius: 3,
                                      border: '1px solid rgba(255,255,255,0.12)',
                                    }}>
                                      <PublicIcon sx={{ color: '#86efac', fontSize: 14 }} />
                                      <Typography variant="caption" sx={{ color: '#e2e8f0', fontWeight: 600, fontSize: '0.75rem' }}>
                                        {project.country_name}
                                      </Typography>
                                    </Box>
                                )}
                                {project.created_by && (
                                    <Box sx={{ 
                                      display: 'flex', alignItems: 'center', gap: 0.8, 
                                      bgcolor: 'rgba(255,255,255,0.1)', backdropFilter: 'blur(8px)',
                                      px: 1.8, py: 0.7, borderRadius: 3,
                                      border: '1px solid rgba(255,255,255,0.12)',
                                    }}>
                                      <PersonIcon sx={{ color: '#93c5fd', fontSize: 14 }} />
                                      <Typography variant="caption" sx={{ color: '#e2e8f0', fontWeight: 600, fontSize: '0.75rem' }}>
                                        {project.created_by}
                                      </Typography>
                                    </Box>
                                )}
                                {project.created_at && (
                                    <Box sx={{ 
                                      display: 'flex', alignItems: 'center', gap: 0.8, 
                                      bgcolor: 'rgba(255,255,255,0.1)', backdropFilter: 'blur(8px)',
                                      px: 1.8, py: 0.7, borderRadius: 3,
                                      border: '1px solid rgba(255,255,255,0.12)',
                                    }}>
                                      <CalendarTodayIcon sx={{ color: '#fde68a', fontSize: 14 }} />
                                      <Typography variant="caption" sx={{ color: '#e2e8f0', fontWeight: 600, fontSize: '0.75rem' }}>
                                        {new Date(project.created_at).toLocaleDateString()}
                                      </Typography>
                                    </Box>
                                )}
                            </Box>
                        </Box>
                        
                        <Box sx={{ display: 'flex', gap: 2, flexDirection: { xs: 'column', sm: 'row' }, width: { xs: '100%', md: 'auto' }, pt: { xs: 2, md: 0 }, alignItems: { xs: 'flex-start', md: 'center' } }}>
                            <Button
                                onClick={handleExportPDF}
                                variant="contained"
                                size="medium"
                                startIcon={<PictureAsPdfIcon />}
                                sx={{
                                    bgcolor: 'rgba(255,255,255,0.2)',
                                    color: 'white',
                                    backdropFilter: 'blur(10px)',
                                    border: '1px solid rgba(255,255,255,0.3)',
                                    '&:hover': {
                                        bgcolor: 'rgba(255,255,255,0.3)',
                                        transform: 'translateY(-2px)'
                                    },
                                    transition: 'all 0.2s',
                                    height: 'fit-content',
                                    fontWeight: 'bold',
                                    px: 3,
                                    borderRadius: 3
                                }}
                            >
                                Export PDF
                            </Button>
                            <Button
                                variant="contained"
                                startIcon={editOpen ? <CloseIcon /> : <EditIcon />}
                                onClick={handleEditClick}
                                sx={{
                                    borderRadius: 3,
                                    bgcolor: editOpen ? 'rgba(244,67,54,0.9)' : 'white',
                                    color: editOpen ? 'white' : '#1e3c72',
                                    fontWeight: 'bold',
                                    px: 3,
                                    boxShadow: '0 4px 14px rgba(0,0,0,0.2)',
                                    '&:hover': { 
                                        bgcolor: editOpen ? '#d32f2f' : '#f0f0f0',
                                        transform: 'translateY(-2px)'
                                    },
                                    transition: 'all 0.2s',
                                    height: 'fit-content'
                                }}
                            >
                                {editOpen ? 'Cancel Edit' : 'Edit Project'}
                            </Button>

                            {/* QR Code Box */}
                            {project.qr_code && (
                                <Box sx={{ 
                                    bgcolor: 'rgba(255,255,255,0.1)', 
                                    backdropFilter: 'blur(10px)',
                                    p: 1.5, 
                                    borderRadius: 3, 
                                    border: '1px solid rgba(255,255,255,0.2)',
                                    textAlign: 'center',
                                    alignSelf: { xs: 'flex-start', md: 'center' },
                                    mt: { xs: 3, md: 0 }
                                }}>
                                    <Box sx={{ bgcolor: 'white', p: 0.5, borderRadius: 1 }}>
                                        <img src={`data:image/png;base64,${project.qr_code}`} alt="QR" style={{ width: 100, height: 100, display: 'block', borderRadius: 4 }} />
                                    </Box>
                                    <Typography variant="caption" sx={{ color: 'white', fontSize: '0.7rem', mt: 1, display: 'block', fontWeight: '800', letterSpacing: 1 }}>
                                        SCAN QR
                                    </Typography>
                                </Box>
                            )}
                        </Box>
                    </Box>
                </Box>
            </Paper>
            </Grow>

            <Grid container spacing={3}>
                {/* Main Content Info */}
                <Grid item xs={12}>
                    <Paper elevation={0} sx={{ borderRadius: 4, overflow: 'hidden', boxShadow: '0 4px 20px rgba(0,0,0,0.04)', minHeight: '400px', bgcolor: 'white', border: '1px solid #f0f0f0' }}>
                        <Tabs 
                            value={tab} 
                            onChange={(e, v) => setTab(v)} 
                            variant="scrollable" 
                            scrollButtons="auto" 
                            TabIndicatorProps={{ sx: { height: 3, borderRadius: '3px 3px 0 0' } }}
                            sx={{ 
                                borderBottom: 1, 
                                borderColor: '#f0f0f0', 
                                bgcolor: 'white', 
                                px: 2,
                                '& .MuiTab-root': { fontWeight: 700, textTransform: 'none', minHeight: 64, fontSize: '0.95rem' }
                            }}
                        >
                            <Tab icon={<DescriptionIcon />} iconPosition="start" label="Overview" />
                            <Tab icon={<AssignmentIcon />} iconPosition="start" label="Tasks" />
                            <Tab icon={<PersonAddIcon />} iconPosition="start" label="Members" />
                            <Tab icon={<WarningIcon />} iconPosition="start" label="Linked Tickets" />
                            <Tab icon={<FactCheckIcon />} iconPosition="start" label="Project Needs" />
                            <Tab icon={<FolderIcon />} iconPosition="start" label="Documents" />
                            <Tab icon={<SendIcon />} iconPosition="start" label="Chat" />
                        </Tabs>

                        <TabPanel value={tab} index={0}>
{editOpen ? (
    <Grid container spacing={3}>
        <Grid item xs={12}>
            <Typography variant="h6" fontWeight="800" color="primary.main" sx={{ mb: 2, borderBottom: '2px solid #e3f2fd', pb: 1 }}>Edit IT Project Details</Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
            <TextField label="Name" fullWidth name="name" value={editData.name || ''} onChange={e => handleEditChange('name', e.target.value)} variant="outlined" />
        </Grid>
        <Grid item xs={12} sm={6}>
            <FormControl fullWidth>
                <InputLabel>Status</InputLabel>
                <Select label="Status" name="status" value={editData.status || ''} onChange={e => handleEditChange('status', e.target.value)}>
                    <MenuItem value="Active">Active</MenuItem>
                    <MenuItem value="In Progress">In Progress</MenuItem>
                    <MenuItem value="Completed">Completed</MenuItem>
                    <MenuItem value="On Hold">On Hold</MenuItem>
                </Select>
            </FormControl>
        </Grid>
        <Grid item xs={12}>
            <TextField 
                label="Description"
                fullWidth multiline rows={4} 
                name="description" 
                value={editData.description || ''} 
                onChange={e => handleEditChange('description', e.target.value)} 
                sx={{ bgcolor: '#f8fafc', '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
            />
        </Grid>
        
        <Grid item xs={12} sm={6}>
            <FormControl fullWidth>
                <InputLabel>Client</InputLabel>
                <Select label="Client" value={editData.client_id || ''} onChange={e => handleEditChange('client_id', e.target.value)}>
                    <MenuItem value=""><em>None</em></MenuItem>
                    {clients.map(c => (
                        <MenuItem key={c.id} value={c.id}>{c.name}</MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Grid>
        <Grid item xs={12} sm={6}>
            <FormControl fullWidth>
                <InputLabel>Country</InputLabel>
                <Select label="Country" value={editData.country_id || ''} onChange={e => handleEditChange('country_id', e.target.value)}>
                    <MenuItem value=""><em>Global</em></MenuItem>
                    {countries.map(c => (
                        <MenuItem key={c.id} value={c.id}>{c.name}</MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Grid>

        <Grid item xs={12} sm={4}>
            <FormControl fullWidth>
                <InputLabel>Priority</InputLabel>
                <Select label="Priority" name="priority" value={editData.priority || 'Medium'} onChange={e => handleEditChange('priority', e.target.value)}>
                    <MenuItem value="Low">Low</MenuItem>
                    <MenuItem value="Medium">Medium</MenuItem>
                    <MenuItem value="High">High</MenuItem>
                    <MenuItem value="Critical">Critical</MenuItem>
                </Select>
            </FormControl>
        </Grid>
        <Grid item xs={12} sm={4}>
            <TextField fullWidth type="date" label="Start Date" name="start_date" value={editData.start_date || ''} onChange={e => handleEditChange('start_date', e.target.value)} InputLabelProps={{ shrink: true }} />
        </Grid>
        <Grid item xs={12} sm={4}>
            <TextField fullWidth type="date" label="Due Date" name="time_limit" value={editData.time_limit || ''} onChange={e => handleEditChange('time_limit', e.target.value)} InputLabelProps={{ shrink: true }} />
        </Grid>
        
        <Grid item xs={12} sx={{ mt: 2, display: 'flex', gap: 2 }}>
            <Button
                variant="contained"
                onClick={handleEditSave}
                startIcon={<SaveIcon />}
                size="large"
                sx={{ 
                    borderRadius: 2, 
                    px: 4, 
                    fontWeight: 'bold', 
                    background: 'linear-gradient(45deg, #1976d2 0%, #42a5f5 100%)',
                    boxShadow: '0 4px 14px rgba(25,118,210,0.4)',
                    '&:hover': { transform: 'translateY(-2px)', boxShadow: '0 6px 20px rgba(25,118,210,0.5)' }
                }}
            >
                Save Changes
            </Button>
            <Button 
                variant="outlined" 
                size="large" 
                onClick={handleEditClose}
                sx={{ borderRadius: 2, fontWeight: 'bold' }}
            >
                Cancel
            </Button>
        </Grid>
    </Grid>
) : (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
        {/* Status Flow container */}
        <Box sx={{ p: 4, bgcolor: '#ffffff', borderRadius: 4, border: '1px solid #f1f5f9', boxShadow: '0 4px 20px rgba(0,0,0,0.03)' }}>
            <Typography variant="h6" fontWeight="800" color="#1e293b" gutterBottom>Workflow Status</Typography>
            <Stepper nonLinear activeStep={activeStep} alternativeLabel sx={{ mt: 3, '& .MuiStepLabel-label': { fontWeight: 700 } }}>
                {steps.map((label, index) => (
                    <Step key={label}>
                        <StepButton color="inherit" onClick={() => handleStepClick(label)}>
                            {label}
                        </StepButton>
                    </Step>
                ))}
            </Stepper>
        </Box>

        {/* Info Cards Grid */}
        <Grid container spacing={3}>
            {/* Description Card */}
            <Grid item xs={12} md={6}>
            <Card elevation={0} sx={{ borderRadius: 4, height: '100%', boxShadow: '0 4px 20px rgba(0,0,0,0.03)', border: '1px solid #f1f5f9', bgcolor: '#ffffff' }}>
                <CardContent sx={{ p: 4 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 3 }}>
                    <DescriptionIcon sx={{ color: '#3b82f6' }} />
                    <Typography variant="h6" sx={{ fontWeight: 800, color: '#1e293b' }}>Project Description</Typography>
                </Box>
                
                <Box sx={{ p: 3, bgcolor: '#f8fafc', borderRadius: 3, border: '1px solid #e2e8f0', minHeight: '120px' }}>
                    <Typography paragraph color="#475569" sx={{ whiteSpace: 'pre-line', lineHeight: 1.7 }}>{project.description || 'No description provided.'}</Typography>
                </Box>
                </CardContent>
            </Card>
            </Grid>

            {/* Health & Tags */}
            <Grid item xs={12} md={6}>
            <Card elevation={0} sx={{ borderRadius: 4, height: '100%', boxShadow: '0 4px 20px rgba(0,0,0,0.03)', border: '1px solid #f1f5f9', bgcolor: '#ffffff' }}>
                <CardContent sx={{ p: 4 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 3 }}>
                    <AssignmentIcon sx={{ color: '#2563eb' }} />
                    <Typography variant="h6" sx={{ fontWeight: 800, color: '#1e293b' }}>Project Overview</Typography>
                </Box>

                <Grid container spacing={2}>
                    <Grid item xs={12} sm={4}>
                        <Box sx={{ textAlign: 'center', p: 2.5, bgcolor: '#f8fafc', borderRadius: 3, border: '1px solid #e2e8f0', transition: 'all 0.2s', '&:hover': { borderColor: '#cbd5e1', bgcolor: '#f1f5f9' } }}>
                            <Typography variant="caption" color="#64748b" fontWeight="bold" textTransform="uppercase" letterSpacing={1}>Status</Typography>
                            <Typography variant="h6" fontWeight="800" color="#334155" mt={1}>{project.status || 'N/A'}</Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Box sx={{ textAlign: 'center', p: 2.5, bgcolor: '#f8fafc', borderRadius: 3, border: '1px solid #e2e8f0', transition: 'all 0.2s', '&:hover': { borderColor: '#cbd5e1', bgcolor: '#f1f5f9' } }}>
                            <Typography variant="caption" color="#64748b" fontWeight="bold" textTransform="uppercase" letterSpacing={1}>Priority</Typography>
                            <Typography variant="h6" fontWeight="800" color={project.priority === 'High' || project.priority === 'Critical' ? '#ef4444' : '#334155'} mt={1}>{project.priority || 'Medium'}</Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Box sx={{ textAlign: 'center', p: 2.5, bgcolor: '#f8fafc', borderRadius: 3, border: '1px solid #e2e8f0', transition: 'all 0.2s', '&:hover': { borderColor: '#cbd5e1', bgcolor: '#f1f5f9' } }}>
                            <Typography variant="caption" color="#64748b" fontWeight="bold" textTransform="uppercase" letterSpacing={1}>Location</Typography>
                            <Typography variant="h6" fontWeight="800" color="#334155" mt={1}>{project.country_name || 'Global'}</Typography>
                        </Box>
                    </Grid>
                    {project.client_name && (
                    <Grid item xs={12}>
                        <Box sx={{ p: 2, bgcolor: '#eff6ff', borderRadius: 3, border: '1px solid #bfdbfe', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                <BusinessIcon sx={{ color: '#1d4ed8' }} />
                                <Typography variant="caption" color="#1e40af" fontWeight="bold" textTransform="uppercase">Client</Typography>
                            </Box>
                            <Typography variant="subtitle1" fontWeight="800" color="#1e3a8a">{project.client_name}</Typography>
                        </Box>
                    </Grid>
                    )}
                </Grid>
                </CardContent>
            </Card>
            </Grid>

            {/* Progress Tracking */}
            <Grid item xs={12} md={6}>
            <Card elevation={0} sx={{ borderRadius: 4, height: '100%', boxShadow: '0 4px 20px rgba(0,0,0,0.03)', border: '1px solid #f1f5f9', bgcolor: '#ffffff' }}>
                <CardContent sx={{ p: 4 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 3 }}>
                    <FlagIcon sx={{ color: '#2563eb' }} />
                    <Typography variant="h6" sx={{ fontWeight: 800, color: '#1e293b' }}>Task Completion</Typography>
                </Box>
                <Box sx={{ mt: 2, mb: 3 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                    <Typography variant="body2" sx={{ fontWeight: 700, color: '#64748b' }}>Overall Progress</Typography>
                    <Typography variant="body2" sx={{ fontWeight: 800, color: '#2563eb' }}>{calculateProgress(project.tasks)}%</Typography>
                    </Box>
                    <LinearProgress 
                    variant="determinate" 
                    value={calculateProgress(project.tasks)} 
                    sx={{ height: 10, borderRadius: 5, bgcolor: '#f1f5f9', '& .MuiLinearProgress-bar': { borderRadius: 5, bgcolor: '#2563eb' } }} 
                    />
                </Box>
                </CardContent>
            </Card>
            </Grid>

            {/* Key Dates */}
            <Grid item xs={12} md={6}>
            <Card elevation={0} sx={{ borderRadius: 4, height: '100%', boxShadow: '0 4px 20px rgba(0,0,0,0.03)', border: '1px solid #f1f5f9', bgcolor: '#ffffff' }}>
                <CardContent sx={{ p: 4 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 3 }}>
                    <EventIcon sx={{ color: '#2563eb' }} />
                    <Typography variant="h6" sx={{ fontWeight: 800, color: '#1e293b' }}>Key Dates</Typography>
                </Box>
                <Grid container spacing={4}>
                    <Grid item xs={12} sm={4}>
                        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2.5 }}>
                            <Avatar sx={{ bgcolor: '#eff6ff', color: '#3b82f6', width: 44, height: 44, boxShadow: '0 2px 10px rgba(59,130,246,0.15)' }}>
                                <EventIcon />
                            </Avatar>
                            <Box>
                                <Typography variant="caption" color="#64748b" fontWeight="700" textTransform="uppercase" letterSpacing={0.5}>Start Date</Typography>
                                <Typography variant="body1" fontWeight="600" color="#1e293b">{project.start_date ? new Date(project.start_date).toLocaleDateString() : 'Not set'}</Typography>
                            </Box>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2.5 }}>
                            <Avatar sx={{ bgcolor: '#fef2f2', color: '#ef4444', width: 44, height: 44, boxShadow: '0 2px 10px rgba(239,68,68,0.15)' }}>
                                <FlagIcon />
                            </Avatar>
                            <Box>
                                <Typography variant="caption" color="#64748b" fontWeight="700" textTransform="uppercase" letterSpacing={0.5}>Due Date</Typography>
                                <Typography variant="body1" fontWeight="600" color="#1e293b">{project.time_limit ? new Date(project.time_limit).toLocaleDateString() : 'Not set'}</Typography>
                            </Box>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2.5 }}>
                            <Avatar sx={{ bgcolor: '#f0fdf4', color: '#22c55e', width: 44, height: 44, boxShadow: '0 2px 10px rgba(34,197,94,0.15)' }}>
                                <AccessTimeIcon />
                            </Avatar>
                            <Box>
                                <Typography variant="caption" color="#64748b" fontWeight="700" textTransform="uppercase" letterSpacing={0.5}>Created</Typography>
                                <Typography variant="body1" fontWeight="600" color="#1e293b">{project.created_at ? new Date(project.created_at).toLocaleDateString() : 'N/A'}</Typography>
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
                </CardContent>
            </Card>
            </Grid>
        </Grid>
    </Box>
)}
                        </TabPanel>

                        <TabPanel value={tab} index={1}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 4, alignItems: 'center' }}>
                                <Typography variant="h6" fontWeight="bold" color="#1e293b">Tasks</Typography>
                                <Button 
                                    variant="contained" 
                                    onClick={() => setOpenTaskDialog(true)} 
                                    startIcon={<AddIcon />} 
                                    sx={{ 
                                        borderRadius: 2, 
                                        px: 3, 
                                        height: 42, 
                                        whiteSpace: 'nowrap',
                                        fontWeight: 'bold',
                                        background: 'linear-gradient(45deg, #1976d2 0%, #42a5f5 100%)',
                                        boxShadow: '0 4px 14px rgba(25,118,210,0.3)',
                                        '&:hover': { transform: 'translateY(-2px)', boxShadow: '0 6px 20px rgba(25,118,210,0.4)', background: 'linear-gradient(45deg, #1565c0 0%, #1e88e5 100%)' }
                                    }}
                                >
                                    Add Task
                                </Button>
                            </Box>

                            <Grow in={true} timeout={1200}>
                                <Paper elevation={0} sx={{ borderRadius: 4, overflow: 'hidden', border: '1px solid #f1f5f9', boxShadow: '0 4px 20px rgba(0,0,0,0.03)', width: '100%', bgcolor: 'white', mb: 4 }}>
                                    <Box sx={{ overflowX: 'auto', width: '100%', display: 'block' }}>
                                        <Table sx={{ width: '100%', tableLayout: 'auto', '& .MuiTableCell-root': { borderColor: '#f0f0f0', py: 2 } }} aria-label="tasks table">
                                            <TableHead sx={{ bgcolor: '#f8fafc' }}>
                                                <TableRow>
                                                    <TableCell sx={{ width: 60 }}></TableCell>
                                                    <TableCell sx={{ fontWeight: '800', color: '#475569', textTransform: 'uppercase', fontSize: '0.75rem', letterSpacing: '0.5px' }}>Task Title</TableCell>
                                                    <TableCell sx={{ fontWeight: '800', color: '#475569', textTransform: 'uppercase', fontSize: '0.75rem', letterSpacing: '0.5px' }}>Assignee</TableCell>
                                                    <TableCell sx={{ fontWeight: '800', color: '#475569', textTransform: 'uppercase', fontSize: '0.75rem', letterSpacing: '0.5px' }}>Dates</TableCell>
                                                    <TableCell sx={{ fontWeight: '800', color: '#475569', textTransform: 'uppercase', fontSize: '0.75rem', letterSpacing: '0.5px', align: 'right' }}>Actions</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {project.tasks && project.tasks.length === 0 && (
                                                    <TableRow>
                                                        <TableCell colSpan={5} align="center" sx={{ py: 6, color: '#94a3b8', fontWeight: 600 }}>
                                                            No active tasks.
                                                        </TableCell>
                                                    </TableRow>
                                                )}
                                                {project.tasks && project.tasks.map((task) => (
                                                    <TableRow 
                                                        key={task.id} 
                                                        hover 
                                                        sx={{ 
                                                            '&:last-child td, &:last-child th': { border: 0 }, 
                                                            bgcolor: task.completed ? '#f8fafc' : 'inherit',
                                                            transition: 'background-color 0.2s',
                                                            '&:hover': { bgcolor: '#f1f5f9 !important' }
                                                        }}
                                                    >
                                                        <TableCell sx={{ pl: 3 }}>
                                                            <IconButton size="small" onClick={() => handleToggleTask(task.id, task.completed)} sx={{ color: task.completed ? '#22c55e' : '#cbd5e1', '&:hover': { color: task.completed ? '#16a34a' : '#94a3b8', bgcolor: 'transparent' } }}>
                                                                {task.completed ? <CheckCircleIcon /> : <RadioButtonUncheckedIcon />}
                                                            </IconButton>
                                                        </TableCell>
                                                        <TableCell>
                                                            <Typography variant="body1" sx={{ textDecoration: task.completed ? 'line-through' : 'none', color: task.completed ? '#94a3b8' : '#1e293b', fontWeight: task.completed ? 500 : 700 }}>
                                                                {task.title}
                                                            </Typography>
                                                        </TableCell>
                                                        <TableCell>
                                                            {task.assigned_to_name ? (
                                                                <Chip
                                                                    avatar={<Avatar sx={{ width: 24, height: 24, fontSize: 11, fontWeight: 'bold' }}>{task.assigned_to_name[0].toUpperCase()}</Avatar>}
                                                                    label={task.assigned_to_fullname || task.assigned_to_name}
                                                                    size="small"
                                                                    sx={{ height: 28, fontSize: '0.8rem', fontWeight: 'bold', bgcolor: '#eff6ff', color: '#1d4ed8', '& .MuiChip-avatar': { bgcolor: '#bfdbfe', color: '#1e40af' } }}
                                                                />
                                                            ) : (
                                                                <Typography variant="body2" color="#94a3b8" sx={{ fontStyle: 'italic' }}>Unassigned</Typography>
                                                            )}
                                                        </TableCell>
                                                        <TableCell>
                                                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                                                                {task.created_at && (
                                                                    <Typography variant="caption" sx={{ color: '#64748b', display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                                        <AccessTimeIcon sx={{ fontSize: 14 }} /> Created: {new Date(task.created_at).toLocaleDateString()}
                                                                    </Typography>
                                                                )}
                                                                {task.due_date && (
                                                                    <Typography variant="caption" sx={{ color: '#475569', fontWeight: 600, display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                                        <EventIcon sx={{ fontSize: 14 }} /> Due: {new Date(task.due_date).toLocaleDateString()}
                                                                    </Typography>
                                                                )}
                                                                {task.completed && task.completed_at && (
                                                                    <Typography variant="caption" sx={{ color: '#22c55e', fontWeight: 600, display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                                        <CheckCircleIcon sx={{ fontSize: 14 }} /> Done: {new Date(task.completed_at).toLocaleDateString()}
                                                                    </Typography>
                                                                )}
                                                            </Box>
                                                        </TableCell>
                                                        <TableCell align="right" sx={{ pr: 3 }}>
                                                            <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                                                                <Tooltip title="Comments">
                                                                    <IconButton size="small" onClick={() => handleOpenCommentDialog(task)} sx={{ bgcolor: task.comments && task.comments.length > 0 ? '#eff6ff' : 'transparent', color: task.comments && task.comments.length > 0 ? '#3b82f6' : '#94a3b8', '&:hover': { bgcolor: '#dbeafe', color: '#2563eb' } }}>
                                                                        <CommentIcon fontSize="small" />
                                                                    </IconButton>
                                                                </Tooltip>
                                                                <Tooltip title="Delete Task">
                                                                    <IconButton size="small" onClick={() => handleDeleteTask(task.id)} sx={{ color: '#cbd5e1', '&:hover': { color: '#ef4444', bgcolor: '#fef2f2' } }}>
                                                                        <DeleteIcon fontSize="small" />
                                                                    </IconButton>
                                                                </Tooltip>
                                                            </Box>
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </Box>
                                </Paper>
                            </Grow>


                          
                        </TabPanel>

                        <TabPanel value={tab} index={2}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 4 }}>
                                <Typography variant="h6" sx={{ fontWeight: 800, color: '#0f172a' }}>Team Members</Typography>
                                <Button 
                                    variant="contained" 
                                    startIcon={<PersonAddIcon />} 
                                    onClick={() => setAssignOpen(true)}
                                    sx={{ 
                                        borderRadius: 2, 
                                        fontWeight: 'bold', 
                                        px: 3, 
                                        boxShadow: '0 4px 14px rgba(25,118,210,0.3)',
                                        background: 'linear-gradient(45deg, #1976d2 0%, #42a5f5 100%)',
                                        '&:hover': { transform: 'translateY(-2px)', boxShadow: '0 6px 20px rgba(25,118,210,0.4)', background: 'linear-gradient(45deg, #1565c0 0%, #1e88e5 100%)' }
                                    }}
                                >
                                    Add Member
                                </Button>
                            </Box>
                            <Grid container spacing={3}>
                                {project.team.map((member) => (
                                    <Grid item xs={12} sm={6} md={4} key={member.id}>
                                        <Card 
                                            elevation={0}
                                            onClick={() => navigate(`/tickets/${ticket.id}`)}
                                            style={{ cursor: 'pointer' }}
                                            sx={{ 
                                                borderRadius: 4,
                                                border: '1px solid #f1f5f9',
                                                transition: 'all 0.2s ease-in-out',
                                                '&:hover': { transform: 'translateY(-4px)', boxShadow: '0 12px 24px -4px rgba(148, 163, 184, 0.15)', borderColor: '#e2e8f0' }
                                            }}
                                        >
                                            <CardContent sx={{ p: 3 }}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2.5, mb: 2.5 }}>
                                                    <Avatar sx={{ bgcolor: '#eff6ff', color: '#0ea5e9', fontWeight: 800, width: 56, height: 56, border: '2px solid white', boxShadow: '0 2px 8px rgba(0,0,0,0.05)' }}>
                                                        {(member.full_name || member.username)[0].toUpperCase()}
                                                    </Avatar>
                                                    <Box>
                                                        <Typography variant="subtitle1" sx={{ fontWeight: 800, color: '#1e293b', mb: 0.5 }} noWrap>
                                                            {member.full_name || member.username}
                                                        </Typography>
                                                        <Chip label={member.role} size="small" sx={{ height: 22, fontSize: '0.7rem', fontWeight: 800, bgcolor: '#f1f5f9', color: '#475569', borderRadius: 1.5 }} />
                                                    </Box>
                                                </Box>
                                                
                                                <Divider sx={{ my: 2, borderStyle: 'dashed' }} />
                                                
                                                <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                                    <IconButton 
                                                        size="small" 
                                                        onClick={() => handleRemoveMember(member.id)} 
                                                        sx={{ bgcolor: '#fef2f2', color: '#ef4444', '&:hover': { bgcolor: '#fee2e2', color: '#b91c1c' } }}
                                                    >
                                                        <DeleteIcon fontSize="small" />
                                                    </IconButton>
                                                </Box>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                ))}
                                {project.team.length === 0 && (
                                    <Grid item xs={12}>
                                        <Paper elevation={0} sx={{ p: 8, textAlign: 'center', bgcolor: '#f8fafc', borderRadius: 4, border: '2px dashed #cbd5e1' }}>
                                            <PersonAddIcon sx={{ fontSize: 64, color: '#94a3b8', mb: 2, opacity: 0.5 }} />
                                            <Typography variant="h6" sx={{ color: '#475569', fontWeight: 700, mb: 1 }}>No team members assigned</Typography>
                                            <Typography variant="body2" sx={{ color: '#94a3b8', mb: 3 }}>Add members to track hours and manage tasks.</Typography>
                                            <Button variant="outlined" onClick={() => setAssignOpen(true)} sx={{ borderRadius: 2, fontWeight: 700, borderWidth: 2, '&:hover': { borderWidth: 2 } }}>
                                                Assign Someone
                                            </Button>
                                        </Paper>
                                    </Grid>
                                )}
                            </Grid>
                        </TabPanel>

                        <TabPanel value={tab} index={3}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 4 }}>
                                <Typography variant="h6" sx={{ fontWeight: 800, color: '#0f172a' }}>Linked Tickets</Typography>
                                <Box sx={{ display: 'flex', gap: 2 }}>
                                    <Button 
                                        variant="outlined" 
                                        startIcon={<WarningIcon />} 
                                        onClick={() => setTicketOpen(true)}
                                        sx={{ 
                                            borderRadius: 2, 
                                            fontWeight: 'bold', 
                                            px: 3,
                                            borderWidth: 2,
                                            '&:hover': { borderWidth: 2 }
                                        }}
                                    >
                                        Link Existing Ticket
                                    </Button>
                                    <Button 
                                        variant="contained" 
                                        startIcon={<AddIcon />} 
                                        onClick={() => setAddTicketOpen(true)}
                                        sx={{ 
                                            borderRadius: 2, 
                                            fontWeight: 'bold', 
                                            px: 3, 
                                            boxShadow: '0 4px 14px rgba(25,118,210,0.3)',
                                            background: 'linear-gradient(45deg, #1976d2 0%, #42a5f5 100%)',
                                            '&:hover': { transform: 'translateY(-2px)', boxShadow: '0 6px 20px rgba(25,118,210,0.4)', background: 'linear-gradient(45deg, #1565c0 0%, #1e88e5 100%)' }
                                        }}
                                    >
                                        New Ticket
                                    </Button>
                                </Box>
                            </Box>
                            <Grid container spacing={3}>
                                {project.tickets.map((ticket) => (
                                    <Grid item xs={12} sm={6} md={4} key={ticket.id}>
                                        <Card 
                                            elevation={0}
                                              onClick={() => navigate(`/tickets/${ticket.id}`)}
                                              style={{ cursor: 'pointer' }}
                                            sx={{ 
                                                borderRadius: 4,
                                                border: '1px solid #f1f5f9',
                                                transition: 'all 0.2s ease-in-out',
                                                '&:hover': { transform: 'translateY(-4px)', boxShadow: '0 12px 24px -4px rgba(148, 163, 184, 0.15)', borderColor: '#e2e8f0' }
                                            }}
                                        >
                                            <CardContent sx={{ p: 3 }}>
                                                <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2.5, mb: 2.5 }}>
                                                    <Avatar sx={{ bgcolor: '#fffbed', color: '#f59e0b', fontWeight: 800, width: 48, height: 48, border: '1px solid #fef3c7', borderRadius: 2 }}>
                                                        <WarningIcon />
                                                    </Avatar>
                                                    <Box sx={{ overflow: 'hidden' }}>
                                                        <Typography variant="subtitle1" sx={{ fontWeight: 800, color: '#1e293b', mb: 0.5, display: '-webkit-box', overflow: 'hidden', WebkitBoxOrient: 'vertical', WebkitLineClamp: 2 }}>
                                                            {ticket.title}
                                                        </Typography>
                                                        <Chip label={ticket.status} size="small" sx={{ height: 22, fontSize: '0.7rem', fontWeight: 800, bgcolor: ticket.status === 'Open' ? '#fef2f2' : ticket.status === 'Done' ? '#f0fdf4' : '#f1f5f9', color: ticket.status === 'Open' ? '#ef4444' : ticket.status === 'Done' ? '#22c55e' : '#475569', borderRadius: 1.5 }} />
                                                    </Box>
                                                </Box>
                                                
                                                <Divider sx={{ my: 2, borderStyle: 'dashed' }} />
                                                
                                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                    <Typography variant="caption" sx={{ color: '#94a3b8', fontWeight: 600 }}>
                                                        ID: {ticket.id}
                                                    </Typography>
                                                    <IconButton 
                                                        size="small" 
                                                        onClick={() => handleRemoveTicket(ticket.id)} 
                                                        sx={{ bgcolor: '#fef2f2', color: '#ef4444', '&:hover': { bgcolor: '#fee2e2', color: '#b91c1c' } }}
                                                    >
                                                        <DeleteIcon fontSize="small" />
                                                    </IconButton>
                                                </Box>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                ))}
                                {project.tickets.length === 0 && (
                                    <Grid item xs={12}>
                                        <Paper elevation={0} sx={{ p: 8, textAlign: 'center', bgcolor: '#f8fafc', borderRadius: 4, border: '2px dashed #cbd5e1' }}>
                                            <WarningIcon sx={{ fontSize: 64, color: '#94a3b8', mb: 2, opacity: 0.5 }} />
                                            <Typography variant="h6" sx={{ color: '#475569', fontWeight: 700, mb: 1 }}>No tickets linked</Typography>
                                            <Typography variant="body2" sx={{ color: '#94a3b8', mb: 3 }}>Create a new ticket or link an existing one to this project.</Typography>
                                            <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
                                                <Button variant="outlined" onClick={() => setTicketOpen(true)} sx={{ borderRadius: 2, fontWeight: 700, borderWidth: 2, '&:hover': { borderWidth: 2 } }}>
                                                    Link Existing Ticket
                                                </Button>
                                                <Button variant="contained" onClick={() => setAddTicketOpen(true)} sx={{ borderRadius: 2, fontWeight: 700, boxShadow: 'none' }}>
                                                    Create New Ticket
                                                </Button>
                                            </Box>
                                        </Paper>
                                    </Grid>
                                )}
                            </Grid>
                        </TabPanel>

                        <TabPanel value={tab} index={4}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 4, alignItems: 'center' }}>
                                <Typography variant="h6" fontWeight="bold" color="#1e293b">Requirements</Typography>
                                <Button 
                                    variant="contained" 
                                    onClick={() => setNeedOpen(true)} 
                                    startIcon={<AddIcon />} 
                                    sx={{ 
                                        borderRadius: 2, 
                                        px: 3, 
                                        height: 42, 
                                        whiteSpace: 'nowrap',
                                        fontWeight: 'bold',
                                        background: 'linear-gradient(45deg, #1976d2 0%, #42a5f5 100%)',
                                        boxShadow: '0 4px 14px rgba(25,118,210,0.3)',
                                        '&:hover': { transform: 'translateY(-2px)', boxShadow: '0 6px 20px rgba(25,118,210,0.4)', background: 'linear-gradient(45deg, #1565c0 0%, #1e88e5 100%)' }
                                    }}
                                >
                                    Add Requirement
                                </Button>
                            </Box>

                            <Grow in={true} timeout={1200}>
                                <Paper elevation={0} sx={{ borderRadius: 4, overflow: 'hidden', border: '1px solid #f1f5f9', boxShadow: '0 4px 20px rgba(0,0,0,0.03)', width: '100%', bgcolor: 'white', mb: 4 }}>
                                    <Box sx={{ overflowX: 'auto', width: '100%', display: 'block' }}>
                                        <Table sx={{ width: '100%', tableLayout: 'auto', '& .MuiTableCell-root': { borderColor: '#f0f0f0', py: 2 } }} aria-label="needs table">
                                            <TableHead sx={{ bgcolor: '#f8fafc' }}>
                                                <TableRow>
                                                    <TableCell sx={{ width: 60 }}></TableCell>
                                                    <TableCell sx={{ fontWeight: '800', color: '#475569', textTransform: 'uppercase', fontSize: '0.75rem', letterSpacing: '0.5px' }}>Requirement</TableCell>
                                                    <TableCell sx={{ fontWeight: '800', color: '#475569', textTransform: 'uppercase', fontSize: '0.75rem', letterSpacing: '0.5px' }}>Priority</TableCell>
                                                    <TableCell sx={{ fontWeight: '800', color: '#475569', textTransform: 'uppercase', fontSize: '0.75rem', letterSpacing: '0.5px' }}>Dates</TableCell>
                                                    <TableCell sx={{ fontWeight: '800', color: '#475569', textTransform: 'uppercase', fontSize: '0.75rem', letterSpacing: '0.5px', align: 'right' }}>Actions</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {project.needs && project.needs.length === 0 && (
                                                    <TableRow>
                                                        <TableCell colSpan={5} align="center" sx={{ py: 6, color: '#94a3b8', fontWeight: 600 }}>
                                                            No requirements listed yet.
                                                        </TableCell>
                                                    </TableRow>
                                                )}
                                                {project.needs && project.needs.map((need, index) => (
                                                    <TableRow 
                                                        key={need.id} 
                                                        hover 
                                                        sx={{ 
                                                            '&:last-child td, &:last-child th': { border: 0 }, 
                                                            bgcolor: need.status === 'Met' ? '#f8fafc' : 'inherit',
                                                            transition: 'background-color 0.2s',
                                                            '&:hover': { bgcolor: '#f1f5f9 !important' }
                                                        }}
                                                    >
                                                        <TableCell sx={{ pl: 3 }}>
                                                            <IconButton size="small" onClick={() => handleToggleNeedStatus(need)} sx={{ color: need.status === 'Met' ? '#22c55e' : '#cbd5e1', '&:hover': { color: need.status === 'Met' ? '#16a34a' : '#94a3b8', bgcolor: 'transparent' } }}>
                                                                {need.status === 'Met' ? <CheckCircleIcon /> : <RadioButtonUncheckedIcon />}
                                                            </IconButton>
                                                        </TableCell>
                                                        <TableCell>
                                                            <Typography variant="body1" sx={{ textDecoration: need.status === 'Met' ? 'line-through' : 'none', color: need.status === 'Met' ? '#94a3b8' : '#1e293b', fontWeight: need.status === 'Met' ? 500 : 700 }}>
                                                                {need.description}
                                                            </Typography>
                                                        </TableCell>
                                                        <TableCell>
                                                            <Chip
                                                                label={need.priority}
                                                                size="small"
                                                                color={need.priority === 'High' ? 'error' : need.priority === 'Medium' ? 'warning' : 'default'}
                                                                variant="outlined"
                                                                sx={{ height: 24, fontSize: '0.75rem', border: 'none', bgcolor: 'grey.100' }}
                                                            />
                                                        </TableCell>
                                                        <TableCell>
                                                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                                                                {need.created_at && (
                                                                    <Typography variant="caption" sx={{ color: '#64748b', display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                                        <AccessTimeIcon sx={{ fontSize: 14 }} /> Created: {new Date(need.created_at).toLocaleDateString()}
                                                                    </Typography>
                                                                )}
                                                                {need.due_date && (
                                                                    <Typography variant="caption" sx={{ color: '#475569', fontWeight: 600, display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                                        <EventIcon sx={{ fontSize: 14 }} /> Due: {new Date(need.due_date).toLocaleDateString()}
                                                                    </Typography>
                                                                )}
                                                                {need.status === 'Met' && need.done_at && (
                                                                    <Typography variant="caption" sx={{ color: '#22c55e', fontWeight: 600, display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                                        <CheckCircleIcon sx={{ fontSize: 14 }} /> Completed: {new Date(need.done_at).toLocaleDateString()}
                                                                    </Typography>
                                                                )}
                                                            </Box>
                                                        </TableCell>
                                                        <TableCell align="right" sx={{ pr: 3 }}>
                                                            <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                                                                <Tooltip title="Comments">
                                                                    <IconButton size="small" onClick={() => handleOpenNeedComments(need)} sx={{ bgcolor: need.comments && need.comments.length > 0 ? '#eff6ff' : 'transparent', color: need.comments && need.comments.length > 0 ? '#3b82f6' : '#94a3b8', '&:hover': { bgcolor: '#dbeafe', color: '#2563eb' } }}>
                                                                        <CommentIcon fontSize="small" />
                                                                    </IconButton>
                                                                </Tooltip>
                                                                <Tooltip title="Delete Requirement">
                                                                    <IconButton size="small" onClick={() => handleDeleteNeed(need.id)} sx={{ color: '#cbd5e1', '&:hover': { color: '#ef4444', bgcolor: '#fef2f2' } }}>
                                                                        <DeleteIcon fontSize="small" />
                                                                    </IconButton>
                                                                </Tooltip>
                                                            </Box>
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </Box>
                                </Paper>
                            </Grow>
                        </TabPanel>


                        <TabPanel value={tab} index={5}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 4, alignItems: 'center' }}>
                                <Typography variant="h6" fontWeight="bold" color="#1e293b">Documents</Typography>
                                <input type="file" hidden ref={fileInputRef} onChange={handleFileUpload} />
                                <Button 
                                    variant="contained" 
                                    onClick={() => fileInputRef.current.click()} 
                                    disabled={uploading}
                                    startIcon={uploading ? <CircularProgress size={20} color="inherit" /> : <CloudUploadIcon />} 
                                    sx={{ 
                                        borderRadius: 2, 
                                        px: 3, 
                                        height: 42, 
                                        whiteSpace: 'nowrap',
                                        fontWeight: 'bold',
                                        background: 'linear-gradient(45deg, #1976d2 0%, #42a5f5 100%)',
                                        boxShadow: '0 4px 14px rgba(25,118,210,0.3)',
                                        '&:hover': { transform: 'translateY(-2px)', boxShadow: '0 6px 20px rgba(25,118,210,0.4)', background: 'linear-gradient(45deg, #1565c0 0%, #1e88e5 100%)' }
                                    }}
                                >
                                    {uploading ? 'Uploading...' : 'Upload File'}
                                </Button>
                            </Box>

                            <Grow in={true} timeout={1200}>
                                <Paper elevation={0} sx={{ borderRadius: 4, overflow: 'hidden', border: '1px solid #f1f5f9', boxShadow: '0 4px 20px rgba(0,0,0,0.03)', width: '100%', bgcolor: 'white', mb: 4 }}>
                                    <Box sx={{ overflowX: 'auto', width: '100%', display: 'block' }}>
                                        <Table sx={{ width: '100%', tableLayout: 'auto', '& .MuiTableCell-root': { borderColor: '#f0f0f0', py: 2 } }} aria-label="documents table">
                                            <TableHead sx={{ bgcolor: '#f8fafc' }}>
                                                <TableRow>
                                                    <TableCell sx={{ fontWeight: '800', color: '#475569', textTransform: 'uppercase', fontSize: '0.75rem', letterSpacing: '0.5px' }}>File Name</TableCell>
                                                    <TableCell sx={{ fontWeight: '800', color: '#475569', textTransform: 'uppercase', fontSize: '0.75rem', letterSpacing: '0.5px' }}>Uploaded At</TableCell>
                                                    <TableCell sx={{ fontWeight: '800', color: '#475569', textTransform: 'uppercase', fontSize: '0.75rem', letterSpacing: '0.5px', align: 'right' }}>Actions</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {project.documents && project.documents.length === 0 && (
                                                    <TableRow>
                                                        <TableCell colSpan={3} align="center" sx={{ py: 6, color: '#94a3b8', fontWeight: 600 }}>
                                                            No documents uploaded.
                                                        </TableCell>
                                                    </TableRow>
                                                )}
                                                {project.documents && project.documents.map((doc) => (
                                                    <TableRow 
                                                        key={doc.id} 
                                                        hover 
                                                        sx={{ 
                                                            '&:last-child td, &:last-child th': { border: 0 }, 
                                                            transition: 'background-color 0.2s',
                                                            '&:hover': { bgcolor: '#f1f5f9 !important' }
                                                        }}
                                                    >
                                                        <TableCell>
                                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                                                <Avatar sx={{ bgcolor: '#eff6ff', color: '#3b82f6', width: 36, height: 36 }}>
                                                                    <DescriptionIcon fontSize="small" />
                                                                </Avatar>
                                                                <Typography variant="body2" fontWeight="600" color="#1e293b">
                                                                    {doc.filename}
                                                                </Typography>
                                                            </Box>
                                                        </TableCell>
                                                        <TableCell>
                                                            <Typography variant="body2" color="#64748b" fontWeight="500">
                                                                {new Date(doc.uploaded_at).toLocaleDateString()}
                                                            </Typography>
                                                        </TableCell>
                                                        <TableCell align="right">
                                                            <Tooltip title="Download">
                                                                <IconButton size="small" onClick={() => handleDownloadDocument(doc)} sx={{ color: '#16a34a', '&:hover': { bgcolor: '#f0fdf4' }, mr: 1 }}>
                                                                    <DownloadIcon fontSize="small" />
                                                                </IconButton>
                                                            </Tooltip>
                                                            <Tooltip title="Delete">
                                                                <IconButton size="small" onClick={() => handleDeleteDocument(doc.id)} sx={{ color: '#ef4444', '&:hover': { bgcolor: '#fef2f2' } }}>
                                                                    <DeleteIcon fontSize="small" />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </Box>
                                </Paper>
                            </Grow>
</TabPanel>

                        <TabPanel value={tab} index={6}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 4, alignItems: 'center' }}>
                                <Typography variant="h6" fontWeight="bold" color="#1e293b">Project Discussion</Typography>
                                <Typography variant="body2" color="#64748b" sx={{ bgcolor: '#f1f5f9', px: 2, py: 0.5, borderRadius: 2, fontWeight: 600 }}>
                                    Live Team Chat
                                </Typography>
                            </Box>

                            <Grow in={true} timeout={1200}>
                                <Paper elevation={0} sx={{ display: 'flex', flexDirection: 'column', height: 600, borderRadius: 4, overflow: 'hidden', border: '1px solid #f1f5f9', boxShadow: '0 4px 20px rgba(0,0,0,0.03)', bgcolor: 'white', mb: 4 }}>
                                    <Box sx={{ p: 2.5, borderBottom: '1px solid', borderColor: '#f1f5f9', bgcolor: '#f8fafc', display: 'flex', alignItems: 'center', gap: 2 }}>
                                        <Avatar sx={{ bgcolor: '#e0e7ff', color: '#2563eb' }}><ForumIcon /></Avatar>
                                        <Box>
                                            <Typography variant="subtitle1" fontWeight="800" color="#1e293b">General Channel</Typography>
                                            <Typography variant="caption" color="#64748b" fontWeight="500">Coordinate and share updates with the project team.</Typography>
                                        </Box>
                                    </Box>

                                    <Box sx={{ flexGrow: 1, overflowY: 'auto', p: 3, bgcolor: '#f8fafc', display: 'flex', flexDirection: 'column', gap: 2 }}>
                                        {project.chats && project.chats.length === 0 && (
                                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%', opacity: 0.5 }}>
                                                <ForumIcon sx={{ fontSize: 64, color: '#94a3b8', mb: 2 }} />
                                                <Typography variant="h6" color="#475569" fontWeight="700">No messages yet</Typography>
                                                <Typography variant="body2" color="#64748b">Break the ice! Start the conversation.</Typography>
                                            </Box>
                                        )}
                                        {project.chats && project.chats.map((chat, idx) => {
                                            const isCurrentUser = chat.user === localStorage.getItem('username');
                                            return (
                                                <Box key={chat.id || idx} sx={{ display: 'flex', flexDirection: 'column', alignItems: isCurrentUser ? 'flex-end' : 'flex-start' }}>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5, px: 0.5, flexDirection: isCurrentUser ? 'row-reverse' : 'row' }}>
                                                        <Avatar sx={{ width: 24, height: 24, fontSize: 11, fontWeight: 'bold', bgcolor: isCurrentUser ? '#2563eb' : '#cbd5e1' }}>
                                                            {chat.user[0].toUpperCase()}
                                                        </Avatar>
                                                        <Typography variant="caption" fontWeight="700" color="#475569">{chat.user}</Typography>
                                                        <Typography variant="caption" color="#94a3b8" fontWeight="500">
                                                            • {new Date(chat.timestamp).toLocaleString([], { hour: '2-digit', minute: '2-digit', month: 'short', day: 'numeric' })}
                                                        </Typography>
                                                    </Box>
                                                    <Paper elevation={0} sx={{ 
                                                        p: 1.5, 
                                                        px: 2.5,
                                                        bgcolor: isCurrentUser ? '#2563eb' : 'white', 
                                                        color: isCurrentUser ? 'white' : '#1e293b',
                                                        borderRadius: 3, 
                                                        borderTopLeftRadius: isCurrentUser ? 16 : 4,
                                                        borderTopRightRadius: isCurrentUser ? 4 : 16,
                                                        border: isCurrentUser ? 'none' : '1px solid #e2e8f0', 
                                                        boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                                                        maxWidth: '75%' 
                                                    }}>
                                                        <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap', lineHeight: 1.5, fontWeight: 500 }}>{chat.message}</Typography>
                                                    </Paper>
                                                </Box>
                                            );
                                        })}
                                    </Box>

                                    <Box sx={{ p: 2.5, bgcolor: 'white', borderTop: '1px solid #f1f5f9' }}>
                                        <Box sx={{ display: 'flex', gap: 1.5, alignItems: 'center' }}>
                                            <TextField
                                                fullWidth
                                                size="small"
                                                variant="outlined"
                                                placeholder="Type your message..."
                                                value={chatMessage}
                                                onChange={e => setChatMessage(e.target.value)}
                                                onKeyPress={(e) => e.key === 'Enter' && handleSendMessage()}
                                                sx={{
                                                    '& .MuiOutlinedInput-root': {
                                                        borderRadius: 3,
                                                        bgcolor: '#f8fafc',
                                                        transition: 'all 0.2s',
                                                        '& fieldset': { borderColor: '#e2e8f0' },
                                                        '&:hover fieldset': { borderColor: '#cbd5e1' },
                                                        '&.Mui-focused fieldset': { borderColor: '#3b82f6', borderWidth: 2 },
                                                    }
                                                }}
                                            />
                                            <IconButton
                                                onClick={handleSendMessage}
                                                disabled={!chatMessage.trim()}
                                                sx={{
                                                    bgcolor: chatMessage.trim() ? '#2563eb' : '#f1f5f9',
                                                    color: chatMessage.trim() ? 'white' : '#94a3b8',
                                                    width: 44, 
                                                    height: 44,
                                                    transition: 'all 0.2s',
                                                    '&:hover': { bgcolor: chatMessage.trim() ? '#1d4ed8' : '#f1f5f9', transform: chatMessage.trim() ? 'scale(1.05)' : 'none' },
                                                    '&.Mui-disabled': { bgcolor: '#f8fafc', color: '#cbd5e1' }
                                                }}
                                            >
                                                <SendIcon fontSize="small" sx={{ ml: 0.5 }} />
                                            </IconButton>
                                        </Box>
                                    </Box>
                                </Paper>
                            </Grow>
</TabPanel>
                    </Paper >
                </Grid >
            </Grid >


            {/* Add Need Dialog */}
            <Dialog open={needOpen} onClose={() => setNeedOpen(false)} maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: 4, width: '100%', maxWidth: 500, overflow: 'visible' } }}>
                <DialogTitle sx={{ fontWeight: 800, pb: 2, fontSize: '1.25rem', color: '#1e293b' }}>Add Requirement</DialogTitle>
                <DialogContent dividers sx={{ borderColor: '#f1f5f9', py: 3, pt: 4, overflow: 'visible' }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                        <TextField
                            fullWidth
                            label="Requirement Description"
                            placeholder="Describe the need..."
                            value={newNeed.description}
                            onChange={e => setNewNeed({ ...newNeed, description: e.target.value })}
                            multiline rows={3}
                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                        />
                        <FormControl fullWidth>
                            <InputLabel>Priority</InputLabel>
                            <Select
                                value={newNeed.priority}
                                label="Priority"
                                onChange={e => setNewNeed({ ...newNeed, priority: e.target.value })}
                                sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                            >
                                <MenuItem value="Low">Low</MenuItem>
                                <MenuItem value="Medium">Medium</MenuItem>
                                <MenuItem value="High">High</MenuItem>
                            </Select>
                        </FormControl>
                        <TextField
                            fullWidth
                            label="Due Date"
                            type="date"
                            InputLabelProps={{ shrink: true }}
                            value={newNeed.due_date}
                            onChange={e => setNewNeed({ ...newNeed, due_date: e.target.value })}
                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                        />
                    </Box>
                </DialogContent>
                <DialogActions sx={{ p: 3, bgcolor: '#f8fafc', borderTop: '1px solid #f1f5f9' }}>
                    <Button 
                        onClick={() => setNeedOpen(false)} 
                        variant="outlined" 
                        sx={{ borderRadius: 2, fontWeight: 'bold', borderColor: '#cbd5e1', color: '#475569', '&:hover': { bgcolor: '#f1f5f9', borderColor: '#94a3b8' } }}
                    >
                        CANCEL
                    </Button>
                    <Button 
                        onClick={handleAddNeed} 
                        variant="contained" 
                        disabled={!newNeed.description}
                        sx={{ 
                            borderRadius: 2, 
                            fontWeight: 'bold', 
                            minWidth: 100,
                            boxShadow: 'none',
                            bgcolor: '#3b82f6',
                            color: 'white',
                            '&:hover': { bgcolor: '#2563eb', boxShadow: 'none' }
                        }}
                    >
                        ADD REQUIREMENT
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Add Task Dialog */}
            <Dialog open={openTaskDialog} onClose={() => setOpenTaskDialog(false)} maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: 4, width: '100%', maxWidth: 500, overflow: 'visible' } }}>
                <DialogTitle sx={{ fontWeight: 800, pb: 2, fontSize: '1.25rem', color: '#1e293b' }}>Add New Task</DialogTitle>
                <DialogContent dividers sx={{ borderColor: '#f1f5f9', py: 3, pt: 4, overflow: 'visible' }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                        <TextField
                            fullWidth
                            label="Task Title"
                            value={newTask}
                            onChange={e => setNewTask(e.target.value)}
                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                        />
                        <TextField
                            fullWidth
                            type="date"
                            label="Due Date"
                            InputLabelProps={{ shrink: true }}
                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                            value={newTaskDate}
                            onChange={(e) => setNewTaskDate(e.target.value)}
                        />
                        <FormControl fullWidth>
                            <InputLabel>Assign To (Optional)</InputLabel>
                            <Select
                                value={newTaskAssignee}
                                label="Assign To (Optional)"
                                onChange={(e) => setNewTaskAssignee(e.target.value)}
                                sx={{ borderRadius: 2 }}
                            >
                                <MenuItem value=""><em>None</em></MenuItem>
                                {project?.team?.map(member => (
                                    <MenuItem key={member.id} value={member.id}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                            <Avatar sx={{ width: 24, height: 24, fontSize: 12, bgcolor: '#eff6ff', color: '#1d4ed8' }}>{member.username[0].toUpperCase()}</Avatar>
                                            {member.full_name || member.username}
                                        </Box>
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Box>
                </DialogContent>
                <DialogActions sx={{ p: 3, bgcolor: '#f8fafc', borderTop: '1px solid #f1f5f9' }}>
                    <Button 
                        onClick={() => setOpenTaskDialog(false)} 
                        variant="outlined" 
                        sx={{ borderRadius: 2, fontWeight: 'bold', borderColor: '#cbd5e1', color: '#475569', '&:hover': { bgcolor: '#f1f5f9', borderColor: '#94a3b8' } }}
                    >
                        CANCEL
                    </Button>
                    <Button 
                        onClick={handleAddTask} 
                        variant="contained" 
                        disabled={!newTask.trim() || addingTask}
                        sx={{ 
                            borderRadius: 2, 
                            fontWeight: 'bold', 
                            minWidth: 100,
                            boxShadow: 'none',
                            bgcolor: '#3b82f6',
                            color: 'white',
                            '&:hover': { bgcolor: '#2563eb', boxShadow: 'none' }
                        }}
                    >
                        {addingTask ? <CircularProgress size={24} color="inherit" /> : 'ADD TASK'}
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Task Comment Dialog */}
            <Dialog open={openCommentDialog} onClose={() => setOpenCommentDialog(false)} maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: 4, height: '70vh', display: 'flex', flexDirection: 'column' } }}>
                <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1.5, borderBottom: '1px solid #f1f5f9', pb: 2 }}>
                    <Avatar sx={{ bgcolor: '#eff6ff', color: '#3b82f6' }}><CommentIcon /></Avatar>
                    <Box>
                        <Typography variant="h6" fontWeight="bold" sx={{ lineHeight: 1.2 }}>Task Comments</Typography>
                        <Typography variant="caption" color="text.secondary">{currentTask?.title}</Typography>
                    </Box>
                </DialogTitle>
                <DialogContent sx={{ flexGrow: 1, p: 3, bgcolor: '#f8fafc', display: 'flex', flexDirection: 'column', gap: 2, overflowY: 'auto' }}>
                    {project && currentTask && project.tasks.find(t => t.id === currentTask.id)?.comments && project.tasks.find(t => t.id === currentTask.id)?.comments.length === 0 && (
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%', color: '#94a3b8' }}>
                            <CommentIcon sx={{ fontSize: 48, mb: 1, opacity: 0.5 }} />
                            <Typography variant="body1" fontWeight={500}>No comments yet</Typography>
                            <Typography variant="body2">Be the first to share your thoughts!</Typography>
                        </Box>
                    )}
                    {project && currentTask && project.tasks.find(t => t.id === currentTask.id)?.comments?.map(comment => {
                        const isCurrentUser = comment.user === localStorage.getItem('username'); // Assuming we can use username to check this, or just style them all uniformly but nicely.
                        return (
                            <Box key={comment.id} sx={{ display: 'flex', flexDirection: 'column', alignItems: isCurrentUser ? 'flex-end' : 'flex-start' }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5, px: 0.5, flexDirection: isCurrentUser ? 'row-reverse' : 'row' }}>
                                    <Avatar sx={{ width: 24, height: 24, fontSize: 10, bgcolor: isCurrentUser ? '#1d4ed8' : '#cbd5e1' }}>{comment.user[0].toUpperCase()}</Avatar>
                                    <Typography variant="caption" fontWeight="bold" color="text.secondary">{comment.user}</Typography>
                                    <Typography variant="caption" color="#cbd5e1">• {new Date(comment.timestamp).toLocaleString([], { hour: '2-digit', minute: '2-digit', month: 'short', day: 'numeric' })}</Typography>
                                </Box>
                                <Paper elevation={0} sx={{ 
                                    p: 1.5, 
                                    px: 2,
                                    borderRadius: 3, 
                                    borderTopLeftRadius: isCurrentUser ? 12 : 2, 
                                    borderTopRightRadius: isCurrentUser ? 2 : 12,
                                    bgcolor: isCurrentUser ? '#3b82f6' : 'white', 
                                    color: isCurrentUser ? 'white' : '#1e293b',
                                    border: isCurrentUser ? 'none' : '1px solid #e2e8f0',
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                                    maxWidth: '85%'
                                }}>
                                    <Typography variant="body2" sx={{ wordBreak: 'break-word', whiteSpace: 'pre-wrap' }}>{comment.comment}</Typography>
                                </Paper>
                            </Box>
                        );
                    })}
                </DialogContent>
                <DialogActions sx={{ p: 2, borderTop: '1px solid #f1f5f9', bgcolor: 'white' }}>
                    <Box sx={{ display: 'flex', width: '100%', gap: 1, alignItems: 'flex-end' }}>
                        <TextField
                            fullWidth
                            multiline
                            maxRows={4}
                            placeholder="Write a comment..."
                            value={taskComment}
                            onChange={(e) => setTaskComment(e.target.value)}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' && !e.shiftKey) {
                                    e.preventDefault();
                                    handleSendTaskComment();
                                }
                            }}
                            variant="outlined"
                            size="small"
                            sx={{ 
                                '& .MuiOutlinedInput-root': { 
                                    borderRadius: 3, 
                                    bgcolor: '#f1f5f9',
                                    fieldset: { border: 'none' },
                                    '&:hover fieldset': { border: 'none' },
                                    '&.Mui-focused fieldset': { border: '1px solid #cbd5e1' }
                                } 
                            }}
                        />
                        <IconButton 
                            color="primary" 
                            onClick={handleSendTaskComment} 
                            disabled={!taskComment.trim()}
                            sx={{ 
                                bgcolor: taskComment.trim() ? '#eff6ff' : 'transparent',
                                mb: 0.5,
                                '&:hover': { bgcolor: '#dbeafe' }
                            }}
                        >
                            <SendIcon />
                        </IconButton>
                    </Box>
                </DialogActions>
            </Dialog>

            {/* Need Comment Dialog */}
            <Dialog open={openNeedCommentDialog} onClose={() => setOpenNeedCommentDialog(false)} maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: 4, height: '70vh', display: 'flex', flexDirection: 'column' } }}>
                <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1.5, borderBottom: '1px solid #f1f5f9', pb: 2 }}>
                    <Avatar sx={{ bgcolor: '#eff6ff', color: '#3b82f6' }}><CommentIcon /></Avatar>
                    <Box>
                        <Typography variant="h6" fontWeight="bold" sx={{ lineHeight: 1.2 }}>Requirement Comments</Typography>
                        <Typography variant="caption" color="text.secondary">{currentNeed?.description}</Typography>
                    </Box>
                </DialogTitle>
                <DialogContent sx={{ flexGrow: 1, p: 3, bgcolor: '#f8fafc', display: 'flex', flexDirection: 'column', gap: 2, overflowY: 'auto' }}>
                    {project && currentNeed && project.needs.find(n => n.id === currentNeed.id)?.comments && project.needs.find(n => n.id === currentNeed.id)?.comments.length === 0 && (
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%', color: '#94a3b8' }}>
                            <CommentIcon sx={{ fontSize: 48, mb: 1, opacity: 0.5 }} />
                            <Typography variant="body1" fontWeight={500}>No comments yet</Typography>
                            <Typography variant="body2">Be the first to share your thoughts!</Typography>
                        </Box>
                    )}
                    {project && currentNeed && project.needs.find(n => n.id === currentNeed.id)?.comments?.map(comment => {
                        const isCurrentUser = comment.user === localStorage.getItem('username');
                        return (
                            <Box key={comment.id} sx={{ display: 'flex', flexDirection: 'column', alignItems: isCurrentUser ? 'flex-end' : 'flex-start' }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5, px: 0.5, flexDirection: isCurrentUser ? 'row-reverse' : 'row' }}>
                                    <Avatar sx={{ width: 24, height: 24, fontSize: 10, bgcolor: isCurrentUser ? '#1d4ed8' : '#cbd5e1' }}>{comment.user[0].toUpperCase()}</Avatar>
                                    <Typography variant="caption" fontWeight="bold" color="text.secondary">{comment.user}</Typography>
                                    <Typography variant="caption" color="#cbd5e1">• {new Date(comment.timestamp).toLocaleString([], { hour: '2-digit', minute: '2-digit', month: 'short', day: 'numeric' })}</Typography>
                                </Box>
                                <Paper elevation={0} sx={{ 
                                    p: 1.5, 
                                    px: 2,
                                    borderRadius: 3, 
                                    borderTopLeftRadius: isCurrentUser ? 12 : 2, 
                                    borderTopRightRadius: isCurrentUser ? 2 : 12,
                                    bgcolor: isCurrentUser ? '#3b82f6' : 'white', 
                                    color: isCurrentUser ? 'white' : '#1e293b',
                                    border: isCurrentUser ? 'none' : '1px solid #e2e8f0',
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                                    maxWidth: '85%'
                                }}>
                                    <Typography variant="body2" sx={{ wordBreak: 'break-word', whiteSpace: 'pre-wrap' }}>{comment.comment}</Typography>
                                </Paper>
                            </Box>
                        );
                    })}
                </DialogContent>
                <DialogActions sx={{ p: 2, borderTop: '1px solid #f1f5f9', bgcolor: 'white' }}>
                    <Box sx={{ display: 'flex', width: '100%', gap: 1, alignItems: 'flex-end' }}>
                        <TextField
                            fullWidth
                            multiline
                            maxRows={4}
                            placeholder="Write a comment..."
                            value={needComment}
                            onChange={(e) => setNeedComment(e.target.value)}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' && !e.shiftKey) {
                                    e.preventDefault();
                                    handleSendNeedComment();
                                }
                            }}
                            variant="outlined"
                            size="small"
                            sx={{ 
                                '& .MuiOutlinedInput-root': { 
                                    borderRadius: 3, 
                                    bgcolor: '#f1f5f9',
                                    fieldset: { border: 'none' },
                                    '&:hover fieldset': { border: 'none' },
                                    '&.Mui-focused fieldset': { border: '1px solid #cbd5e1' }
                                } 
                            }}
                        />
                        <IconButton 
                            color="primary" 
                            onClick={handleSendNeedComment} 
                            disabled={!needComment.trim()}
                            sx={{ 
                                bgcolor: needComment.trim() ? '#eff6ff' : 'transparent',
                                mb: 0.5,
                                '&:hover': { bgcolor: '#dbeafe' }
                            }}
                        >
                            <SendIcon />
                        </IconButton>
                    </Box>
                </DialogActions>
            </Dialog>

            {/* Assign Member Dialog */}
            <Dialog open={assignOpen} onClose={() => setAssignOpen(false)} PaperProps={{ sx: { borderRadius: 4, width: '100%', maxWidth: 500, overflow: 'visible' } }}>
                <DialogTitle sx={{ fontWeight: 800, pb: 2, fontSize: '1.25rem', color: '#1e293b' }}>
                    Assign Team Member
                </DialogTitle>
                <DialogContent dividers sx={{ borderColor: '#f1f5f9', py: 3, pt: 4, overflow: 'visible' }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                        <Autocomplete
                            options={users.filter(u => !project.team.some(m => m.id === u.id))}
                            getOptionLabel={(option) => `${option.full_name || option.username} (${option.role || 'User'})`}
                            value={selectedUser}
                            onChange={(event, newValue) => setSelectedUser(newValue)}
                            renderInput={(params) => (
                                <TextField 
                                    {...params} 
                                    label="Select User" 
                                    placeholder="Search user..." 
                                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                />
                            )}
                            sx={{ '& .MuiAutocomplete-paper': { borderRadius: 2, boxShadow: '0 4px 20px rgba(0,0,0,0.1)' } }}
                        />
                        <FormControl fullWidth sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}>
                            <InputLabel>Project Role</InputLabel>
                            <Select
                                value={assignRole}
                                label="Project Role"
                                onChange={(e) => setAssignRole(e.target.value)}
                            >
                                <MenuItem value="Manager">Manager</MenuItem>
                                <MenuItem value="Lead">Lead</MenuItem>
                                <MenuItem value="Developer">Developer</MenuItem>
                                <MenuItem value="Tester">Tester</MenuItem>
                                <MenuItem value="Designer">Designer</MenuItem>
                                <MenuItem value="Viewer">Viewer</MenuItem>
                                <MenuItem value="Member">Member</MenuItem>
                            </Select>
                        </FormControl>
                    </Box>
                </DialogContent>
                <DialogActions sx={{ p: 3, bgcolor: '#f8fafc', borderTop: '1px solid #f1f5f9' }}>
                    <Button 
                        onClick={() => setAssignOpen(false)} 
                        variant="outlined" 
                        sx={{ borderRadius: 2, fontWeight: 'bold', borderColor: '#cbd5e1', color: '#475569', '&:hover': { bgcolor: '#f1f5f9', borderColor: '#94a3b8' } }}
                    >
                        CANCEL
                    </Button>
                    <Button 
                        onClick={handleAssignMember} 
                        variant="contained" 
                        disabled={!selectedUser || assigningMember}
                        sx={{ 
                            borderRadius: 2, 
                            fontWeight: 'bold', 
                            minWidth: 100,
                            boxShadow: 'none',
                            bgcolor: '#3b82f6',
                            color: 'white',
                            '&:hover': { bgcolor: '#2563eb', boxShadow: 'none' }
                        }}
                    >
                        {assigningMember ? <CircularProgress size={24} color="inherit" /> : 'ASSIGN'}
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Link Ticket Dialog */}
            <Dialog open={ticketOpen} onClose={() => setTicketOpen(false)} PaperProps={{ sx: { borderRadius: 4, width: '100%', maxWidth: 500, overflow: 'visible' } }}>
                <DialogTitle sx={{ fontWeight: 800, pb: 2, fontSize: '1.25rem', color: '#1e293b' }}>
                    Link Ticket
                </DialogTitle>
                <DialogContent dividers sx={{ borderColor: '#f1f5f9', py: 3, pt: 4, overflow: 'visible' }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                        <Autocomplete
                            options={allTickets.filter(t => !project.tickets.some(pt => pt.id === t.id))}
                            getOptionLabel={(option) => `#${option.id} - ${option.title || ''} (${option.status || 'Open'})`}
                            value={selectedTicket}
                            onChange={(event, newValue) => setSelectedTicket(newValue)}
                            renderInput={(params) => (
                                <TextField 
                                    {...params} 
                                    label="Select Ticket" 
                                    placeholder="Search tickets by ID or title..." 
                                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                />
                            )}
                            sx={{ '& .MuiAutocomplete-paper': { borderRadius: 2, boxShadow: '0 4px 20px rgba(0,0,0,0.1)' } }}
                        />
                    </Box>
                </DialogContent>
                <DialogActions sx={{ p: 3, bgcolor: '#f8fafc', borderTop: '1px solid #f1f5f9' }}>
                    <Button 
                        onClick={() => setTicketOpen(false)} 
                        variant="outlined" 
                        sx={{ borderRadius: 2, fontWeight: 'bold', borderColor: '#cbd5e1', color: '#475569', '&:hover': { bgcolor: '#f1f5f9', borderColor: '#94a3b8' } }}
                    >
                        CANCEL
                    </Button>
                    <Button 
                        onClick={handleLinkTicket} 
                        variant="contained" 
                        disabled={!selectedTicket || linkingTicket}
                        sx={{ 
                            borderRadius: 2, 
                            fontWeight: 'bold', 
                            minWidth: 100,
                            boxShadow: 'none',
                            bgcolor: '#3b82f6',
                            color: 'white',
                            '&:hover': { bgcolor: '#2563eb', boxShadow: 'none' }
                        }}
                    >
                        {linkingTicket ? <CircularProgress size={24} color="inherit" /> : 'LINK TICKET'}
                    </Button>
                </DialogActions>
            </Dialog>
            {/* Add New Ticket Dialog */}
            <Dialog open={addTicketOpen} onClose={() => setAddTicketOpen(false)} PaperProps={{ sx: { borderRadius: 2, width: '100%', maxWidth: 800, overflow: 'visible' } }}>
                <DialogTitle sx={{ fontWeight: 800, pb: 2, fontSize: '1.25rem', color: '#1e293b' }}>
                    Create New Ticket
                </DialogTitle>
                <DialogContent dividers sx={{ borderColor: '#f1f5f9', py: 3, pt: 4, overflow: 'visible' }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                        <TextField
                            label="Title / Subject"
                            placeholder="Brief issue description..."
                            fullWidth
                            value={newTicket.title}
                            onChange={(e) => setNewTicket({...newTicket, title: e.target.value})}
                            required
                        />

                        <Box sx={{ display: 'flex', gap: 2 }}>
                            <FormControl fullWidth>
                                <InputLabel>Type</InputLabel>
                                <Select
                                    value={newTicket.ticket_type_id}
                                    label="Type"
                                    onChange={e => setNewTicket({ ...newTicket, ticket_type_id: e.target.value })}
                                >
                                    {ticketTypes.map((t) => (
                                        <MenuItem key={t.id} value={t.id}>{t.name}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <FormControl fullWidth>
                                <InputLabel>Priority</InputLabel>
                                <Select
                                    value={newTicket.priority}
                                    label="Priority"
                                    onChange={e => setNewTicket({ ...newTicket, priority: e.target.value })}
                                >
                                    <MenuItem value="Low">Low</MenuItem>
                                    <MenuItem value="Medium">Medium</MenuItem>
                                    <MenuItem value="High">High</MenuItem>
                                    <MenuItem value="Critical">Critical</MenuItem>
                                </Select>
                            </FormControl>
                            <FormControl fullWidth>
                                <InputLabel>Country</InputLabel>
                                <Select
                                    value={newTicket.country_id}
                                    label="Country"
                                    onChange={e => setNewTicket({ ...newTicket, country_id: e.target.value })}
                                >
                                    <MenuItem value="">
                                        <em>None</em>
                                    </MenuItem>
                                    {countries.map((c) => (
                                        <MenuItem key={c.id} value={c.id}>{c.name}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Box>

                        <Box sx={{ display: 'flex', gap: 2 }}>
                            <Autocomplete
                                freeSolo
                                fullWidth
                                options={adUsers}
                                loading={adLoading}
                                getOptionLabel={(option) => {
                                    if (typeof option === 'string') return option;
                                    return option.displayName || option.name || '';
                                }}
                                onInputChange={(event, newInputValue) => {
                                    handleADSearch(newInputValue);
                                }}
                                renderOption={(props, option) => (
                                    <li {...props}>
                                        <Box>
                                            <Typography variant="body1">{option.displayName || option.name}</Typography>
                                            {option.mail && <Typography variant="caption" color="textSecondary">{option.mail}</Typography>}
                                            {option.country && <Typography variant="caption" color="textSecondary" sx={{ ml: 1 }}>({option.country})</Typography>}
                                        </Box>
                                    </li>
                                )}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Requested By (Azure AD)"
                                        InputProps={{
                                            ...params.InputProps,
                                            endAdornment: (
                                                <React.Fragment>
                                                    {adLoading ? <CircularProgress color="inherit" size={20} /> : null}
                                                    {params.InputProps.endAdornment}
                                                </React.Fragment>
                                            ),
                                        }}
                                    />
                                )}
                                value={newTicket.requested_by}
                                onChange={async (event, newValue) => {
                                    if (typeof newValue === 'string') {
                                        setNewTicket({ ...newTicket, requested_by: newValue });
                                        // Try to fetch from Azure AD if email-like
                                        if (newValue.includes('@')) {
                                            try {
                                                const res = await axios.get(`${API_URL}/tickets/check-ad-user?email=${newValue}`, { headers });
                                                if (res.data.found && res.data.country_id) {
                                                    setNewTicket(prev => ({ ...prev, country_id: res.data.country_id }));
                                                }
                                            } catch (e) { console.log("AD Check failed", e); }
                                        }
                                    } else if (newValue) {
                                        const name = newValue.displayName || newValue.name;
                                        const email = newValue.mail || newValue.sender_email;

                                        let updates = { ...newTicket, requested_by: name, sender_email: email || newTicket.sender_email };

                                        // If AD user has country
                                        if (newValue.country) {
                                            const matchedCountry = countries.find(c => c.name === newValue.country);
                                            if (matchedCountry) {
                                                updates.country_id = matchedCountry.id;
                                            }
                                        }
                                        // If local user has countries
                                        else if (newValue.countries && newValue.countries.length > 0) {
                                            const cName = newValue.countries[0];
                                            const cObj = countries.find(c => c.name === cName);
                                            if (cObj) {
                                                updates.country_id = cObj.id;
                                            }
                                        }

                                        setNewTicket(updates);
                                    } else {
                                        setNewTicket({ ...newTicket, requested_by: '' });
                                    }
                                }}
                            />
                            <TextField
                                fullWidth
                                label="Sender Email"
                                value={newTicket.sender_email}
                                onChange={e => setNewTicket({ ...newTicket, sender_email: e.target.value })}
                            />
                        </Box>

                        <Box sx={{ display: 'flex', gap: 2 }}>
                            <TextField
                                fullWidth
                                type="date"
                                label="Due Date"
                                value={newTicket.due_date}
                                onChange={e => setNewTicket({ ...newTicket, due_date: e.target.value })}
                                InputLabelProps={{ shrink: true }}
                            />
                            <FormControl fullWidth>
                                <InputLabel>Assign To (Team)</InputLabel>
                                <Select
                                    multiple
                                    value={newTicket.assigned_to_ids || []}
                                    onChange={(e) => {
                                        const { target: { value } } = e;
                                        setNewTicket({
                                            ...newTicket,
                                            assigned_to_ids: typeof value === 'string' ? value.split(',') : value,
                                        });
                                    }}
                                    input={<OutlinedInput label="Assign To (Team)" />}
                                    renderValue={(selected) => (
                                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                            {selected.map((value) => {
                                                const user = users.find(u => u.id === value);
                                                return <Chip key={value} label={user ? (user.full_name || user.username) : value} size="small" />;
                                            })}
                                        </Box>
                                    )}
                                >
                                    {users.map((u) => (
                                        <MenuItem key={u.id} value={u.id}>{u.full_name || u.username}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Box>

                        <TextField
                            label="Detailed Description"
                            placeholder="Provide any relevant details..."
                            fullWidth
                            multiline
                            rows={4}
                            value={newTicket.description}
                            onChange={(e) => setNewTicket({...newTicket, description: e.target.value})}
                        />
                    </Box>
                </DialogContent>
                <DialogActions sx={{ p: 3, bgcolor: '#f8fafc', borderTop: '1px solid #f1f5f9' }}>
                    <Button 
                        onClick={() => setAddTicketOpen(false)} 
                        variant="outlined" 
                        sx={{ borderRadius: 2, fontWeight: 'bold', borderColor: '#cbd5e1', color: '#475569', '&:hover': { bgcolor: '#f1f5f9', borderColor: '#94a3b8' } }}
                    >
                        CANCEL
                    </Button>
                    <Button 
                        onClick={handleCreateTicket} 
                        variant="contained" 
                        disabled={!newTicket.title?.trim() || addingTicket}
                        sx={{ 
                            borderRadius: 2, 
                            fontWeight: 'bold', 
                            minWidth: 100,
                            boxShadow: 'none',
                            bgcolor: '#3b82f6',
                            color: 'white',
                            '&:hover': { bgcolor: '#2563eb', boxShadow: 'none' }
                        }}
                    >
                        {addingTicket ? <CircularProgress size={24} color="inherit" /> : 'CREATE TICKET'}
                    </Button>
                </DialogActions>
            </Dialog>

        </Box >
    );
}

export default ITProjectDetails;
